import { InitialIntegrationReducer } from "../../../../_services/store/InitialIntegrationReducer";
import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_NEW_CONFIGURATION, integrationReducerActions } from "../../../../_commons/integration.reducer";

export const initialOttoPaymentsReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: {
        ...INITIAL_NEW_CONFIGURATION,
    },
};

const ottoPaymentsSlice = createSlice({
    name: "Otto Payments",
    initialState: { ...initialOttoPaymentsReducer },
    reducers: {
        ...integrationReducerActions,
    },
});

export default ottoPaymentsSlice;
